const OtherContactItem = (props) => {
    const { id, name } = props;

    return `
        <div class="grid-row register-form-other-contacts__item">
            <div class="grid-col grid-col-8">
                <input
                    type="text"
                    name="${id}[]"
                    class="control-input"
                    placeholder="${name}"
                    value=""
                    required
                />
            </div>
            <div class="grid-col grid-col-4">
                <button type="button" class="button button--wide register-form__remove-contact">Remove</button>
            </div>
        </div>
    `;
};

export default OtherContactItem;
